import { IPdfHtmlData } from "../Common/Models";
import { PrintAxios } from "../Contracts/Axios/PrintAxios";

export const ImageDataUrlsToPdf = (
    filenameNoExtension: string,
    dataUrls: string[]
) => {
    const printAxios = new PrintAxios();
    return printAxios.ImageDataUrlsToPdf(filenameNoExtension, dataUrls);
};

export const PdfNewTab = (
    product: string,
    jobId: string,
    dataUrls: string[]
): Promise<string> => {
    const printAxios = new PrintAxios();
    return printAxios.PdfNewTab(product, jobId, dataUrls);
};

export const PdfLambda = (
    allHtml: IPdfHtmlData[]
): Promise<string> => {
    const printAxios = new PrintAxios();
    return printAxios.PdfLambda(allHtml);
};
